import Businesses from 'app/interface/redux/types/data/generic/businesses'

const Default: Businesses = {
  data: [],
  loading: true,
  timestamp: +new Date(),
}

export default Default
